import api from "./api";
class Services {
    login(params) {
        return api.post("/security/login", params)
    }
    logout() {
        return api.post("/security/logout")
    }
    getCodebook() {
        return api.get("system/codebook-data/find-all")
    }
    getDomainCatalogServiceLookup() {
        return api.get("/domain/catalog/service/lookup")
    }
    getFunctionalUnits(params) {
        return api.post("/score/functional-unit/search", params)
    }
    getFunctionalUnitById(params) {
        return api.post("/score/functional-unit/search/one", params)
    }
    getDomainAssessments(params) {
        return api.post("/domain/assessment/search", params)
    }
    getFunctionalUnitsWithDetailedScores(params) {
        return api.post("/score/functional-unit/search/detailed", params)
    }
    getWeights(params) {
        return api.post("/score/weight/search", params)
    }
    getSriScores(params) {
        return api.post("/score/calculate", params)
    }
    saveSriScores(params) {
        return api.post("/score/calculate/save", params)
    }

    saveOrUpdateFunctionalUnit(params) {
        return api.post("/building/functional-unit/save-or-update", params)
    }
    checkEditPermission(params) {
        return api.post("/building/functional-unit/permission/check", params)
    }
    saveOrUpdateAssessment(params) {
        return api.post("/domain/assessment/save-or-update", params)
    }
    createPasswordResetToken(params) {
        return api.post("/token/account/password-reset/create", params)
    }
    consumePasswordResetToken(params) {
        return api.post("/token/account/password-reset/consume", params)
    }
    savePersonalAccessToken(params) {
        return api.post("/device/personal-access-token/save", params)
    }
    saveAsset(params) {
        return api.post("/device/asset/save", params)
    }
    saveImpactWeights(params) {
        return api.post("/score/weight/user-defined/impact/save-or-update", params);
    }
    saveDomainWeights(params) {
        return api.post("/score/weight/user-defined/domain/save-or-update", params);
    }
    getAssets() {
        return api.get("/device/asset/get");
    }
}
export default new Services();
